function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { PropTypes } from 'prop-types';
import cx from 'classnames';
import _omit from 'lodash/omit';
import Icon from '../Icon';
import { getValidElementProps } from '../utils/htmlValidProps';

require('xps-style/core/tag.css');

var Tag = function Tag(props) {
  var borderless = props.borderless,
      children = props.children,
      className = props.className,
      dark = props.dark,
      disabled = props.disabled,
      onClose = props.onClose,
      iconColor = props.iconColor,
      label = props.label,
      size = props.size;

  var componentProps = _omit(getValidElementProps('div', props), ['onClose']);

  var componentClass = cx(_defineProperty({
    tag: true,
    'tag-skin': !borderless && !dark,
    'tag-skin--borderless': borderless,
    'tag-skin--dark': dark,
    'tag-skin--disabled': disabled
  }, "tag--".concat(size), true), className);
  var iconClass = cx({
    'dds-icons': true,
    tag__icon: true
  });
  var closeBtnClass = cx({
    'dds-icons': true,
    tag__closeBtn: true
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: componentClass
  }, componentProps), iconColor && /*#__PURE__*/React.createElement("div", {
    className: iconClass,
    style: {
      backgroundColor: iconColor
    }
  }), label && /*#__PURE__*/React.createElement("div", {
    className: "tag__label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "tag__content"
  }, children), onClose && /*#__PURE__*/React.createElement("button", {
    className: closeBtnClass,
    onClick: function onClick(e) {
      e.stopPropagation();
      onClose(e);
    },
    onKeyDown: function onKeyDown(e) {
      e.stopPropagation();
      e.key === 'Enter' && onClose(e);
    },
    type: "button",
    disabled: disabled,
    "aria-label": "Clear ".concat(label, " ").concat(children, " tag")
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "clear",
    role: "presentation"
  })));
};

Tag.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  borderless: PropTypes.bool,
  dark: PropTypes.bool,
  disabled: PropTypes.bool,
  onClose: PropTypes.func,
  iconColor: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.oneOf(['large', 'small'])
};
Tag.defaultProps = {
  size: 'large'
};
Tag.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Tag",
  "props": {
    "size": {
      "defaultValue": {
        "value": "'large'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'large'",
          "computed": false
        }, {
          "value": "'small'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "borderless": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "dark": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onClose": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
export default Tag;